// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3ObWW","search":"Settings_search__2_qNK","filter":"Settings_filter__2DIoW"};